import { render, staticRenderFns } from "./RehabCoursesPerson.vue?vue&type=template&id=5a4497f3&scoped=true"
import script from "./RehabCoursesPerson.vue?vue&type=script&lang=js"
export * from "./RehabCoursesPerson.vue?vue&type=script&lang=js"
import style0 from "./RehabCoursesPerson.vue?vue&type=style&index=0&id=5a4497f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4497f3",
  null
  
)

export default component.exports